import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

import OrganLayout from "../../layouts/OrganLayout/OrganLayout";
import DashboardOrgan from "../../components/Organ/DashboardOrgan/DashboardOrgan";
import OrderOrganContext from "../../context/Organ/OrderOrganContext/OrderOrganContext";
import OrderOrgan from "../../components/Organ/OrderOrgan/OrderOrgan";
import { setUserInfoAction } from "../../redux/actions/userInfoActions/userInfoActions";
import { setAppConfigsAction } from "./../../redux/actions/appConfigsActions/appConfigsActions";
import { setCitiesAction } from "./../../redux/actions/citiesActions/citiesActions";
import { baseOrganRoute, getCookies } from "../../utils";

const OrganContainer = () => {
  const dispatch = useDispatch();

  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  useEffect(() => {
    if (accessToken) {
      dispatch(setUserInfoAction());
      dispatch(setCitiesAction());
      dispatch(setAppConfigsAction());
    }
  }, []);

  if (!isLogin) return <Navigate to={baseOrganRoute("/")} />;

  return (
    <OrganLayout>
      <Routes>
        {/* Edit Admin Profile Component */}
        {/* <Route path="/Profile/Edit" element={<EditProfileAdmin />} /> */}

        {/* Orders Component */}
        <Route
          path="/Orders"
          element={
            <OrderOrganContext>
              <OrderOrgan />
            </OrderOrganContext>
          }
        />

        {/* Dashboard Component */}
        <Route path="/Dashboard" element={<DashboardOrgan />} />

        {/* Redirect Not Found Page */}
        <Route
          path="*"
          element={<Navigate to={baseOrganRoute("/Not-Found")} />}
        />
      </Routes>
    </OrganLayout>
  );
};

export default OrganContainer;
